export const SET_AUTHENTICATED_PROFILE = '@user/SET_AUTHENTICATED_PROFILE';
export const SET_SANDBOX_ACCOUNT = '@user/SET_SANDBOX_ACCOUNT';
